<template>
  <div :class="['item', 'item--' + type, disabled ? 'item--disabled' : '', true || activeFilter ? 'item--' + type + 'Active' : '']" :key="value.id">
    <div
      v-if="type === 'timeline'"
      class="item--timeline"
      @click="clicked(value)"
    >
      <div :class="['item__timeline', selectedChartTimeline === value.name ? 'item__timeline--selected' : '', value.disabled ? 'item__timeline--disabled' : '']">
        {{ value.name }}
      </div>
    </div>

    <div
      v-else-if="type === 'legend'"
      :class="['item--legend', value.disabled ? 'item--inactive' : 'item--active']"
      @mouseover="highlighted(value.name)"
      @mouseout="downplayed(value.name)"
      @click="clicked(value)"
    >
      <div
        class="item__legendIcon"
        :style="'background-color: ' + value.color + ';'"
      />
      <div class="item__legendName">{{ value.name }}</div>
    </div>

    <div
      v-else
      class="item--filter"
    >
      <div
        class="item__icon"
        v-html="icons[type]"
      />

      <div
        class="item__text"
        v-html="value.attributes.name"
      />

      <div
        class="item__close"
        content="Remove filter"
        v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
        @click="clicked(value)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
      </div>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    value: {
      type: [Object, String],
      default: ''
    },
    icon: {
      String,
      default: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M16.786 5.799l1.507-1.506c-.188-.392-.293-.83-.293-1.293 0-1.656 1.344-3 3-3s3 1.344 3 3-1.344 3-3 3c-.463 0-.901-.105-1.293-.293l-1.48 1.481c1.109 1.373 1.773 3.12 1.773 5.02 0 1.795-.592 3.452-1.591 4.787l1.298 1.298c.392-.188.83-.293 1.293-.293 1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3c0-.463.105-.901.293-1.293l-1.272-1.272c-1.373 1.109-3.12 1.773-5.021 1.773-1.901 0-3.648-.664-5.021-1.773l-1.272 1.272c.188.392.293.83.293 1.293 0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3c.463 0 .901.105 1.293.293l1.298-1.298c-.999-1.335-1.591-2.992-1.591-4.787 0-1.9.664-3.647 1.773-5.02l-1.48-1.481c-.392.188-.83.293-1.293.293-1.656 0-3-1.344-3-3s1.344-3 3-3 3 1.344 3 3c0 .463-.105.901-.293 1.293l1.507 1.506c1.335-.999 2.992-1.591 4.786-1.591 1.794 0 3.451.592 4.786 1.591zm4.214 14.201c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-18 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm9-13.792c3.311 0 6 2.689 6 6 0 3.312-2.689 6-6 6s-6-2.688-6-6c0-3.311 2.689-6 6-6zm.133 2.884c-.069-.21.088-.425.306-.425.135 0 .261.085.306.221l1.897 4.762c.057.17-.035.352-.204.409-.169.056-.352-.036-.408-.205 0 0-1.198-.401-2.618.07l.934 1.452c.097.142.029.337-.132.391l-.635.211-.134.022c-.119 0-.235-.051-.317-.143l-1.283-1.416c-.699.221-1.489-.034-1.753-.692-.061-.151-.092-.312-.092-.473 0-.469.262-.948.831-1.227 2.847-1.398 3.302-2.957 3.302-2.957zm2.022.304c.506.214.93.622 1.153 1.172.223.551.203 1.14-.011 1.647l.491.209c.139-.329.212-.685.212-1.047 0-1.056-.624-2.045-1.637-2.473l-.208.492zm-.354.841c.291.123.536.358.664.675.128.317.117.656-.006.948l.479.203c.174-.415.192-.897.009-1.347-.182-.451-.529-.784-.944-.959l-.202.48zm-10.801-8.237c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm18 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"/></svg>'
    },
    type: {
      type: String,
      default: 'default',
      validator (values) {
        return ['default', 'queries', 'topics', 'locations', 'trade_types', 'scales', 'providers', 'titles', 'descriptions', 'data_series', 'published', 'timeline', 'legend'].includes(values)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icons: {
        queries: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M11 9.275c0 5.141-3.892 10.519-10 11.725l-.984-2.126c2.215-.835 4.163-3.742 4.38-5.746-2.491-.392-4.396-2.547-4.396-5.149 0-3.182 2.584-4.979 5.199-4.979 3.015 0 5.801 2.305 5.801 6.275zm13 0c0 5.141-3.892 10.519-10 11.725l-.984-2.126c2.215-.835 4.163-3.742 4.38-5.746-2.491-.392-4.396-2.547-4.396-5.149 0-3.182 2.584-4.979 5.199-4.979 3.015 0 5.801 2.305 5.801 6.275z"/></svg>',
        topics: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M20 9.352c0-4.852-4.75-8.352-10-8.352-5.281 0-10 3.527-10 8.352 0 1.71.615 3.39 1.705 4.695.047 1.527-.85 3.719-1.66 5.312 2.168-.391 5.252-1.258 6.648-2.115 7.698 1.877 13.307-2.842 13.307-7.892zm-14.5 1.381c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm7.036 1.441c-.161.488-.361.961-.601 1.416 1.677 1.262 2.257 3.226.464 5.365-.021.745-.049 1.049.138 1.865-.892-.307-.979-.392-1.665-.813-2.127.519-4.265.696-6.089-.855-.562.159-1.145.278-1.74.364 1.513 1.877 4.298 2.897 7.577 2.1.914.561 2.933 1.127 4.352 1.385-.53-1.045-1.117-2.479-1.088-3.479 1.755-2.098 1.543-5.436-1.348-7.348z"/></svg>',
        locations: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M11.239 7.237c-.004-.009-.288-.017-.24-.078l.137-.085c.013-.077.072-.162-.007-.304l.047-.125-.1.029s.141-.606.33-.332l-.08.093c.122.122.155.426.195.623.115.06.294.071.088.175.106-.018-.561.286-.648.161-.065-.076.288-.127.278-.157zm-.715-.159c-.077.078.003.128.082.094.114-.05.269-.048.284-.202l.073-.091-.101-.135c-.06-.012-.1.064-.137.095l-.066.017-.062.08.007.044-.08.098zm7 9.167l-.733-1.206-.724-1.186c-.73-1.194-1.388-2.276-1.961-3.296l-.07.067c-.376.156-.942-.509-1.339-.531.192.03.018-.49.018-.524-.153-.189-1.123.021-1.378.055-.479.063-.979.057-1.346.355-.258.21-.262.551-.524.716-.17.106-.356.072-.502.209-.258.245-.553.607-.697.929-.062.135.077.458.043.632-.336 1.063.085 2.538 1.375 2.701.312.039.638.209.955.114.252-.076.474-.248.745-.268.377-.025.22.529.737.379.251-.074.365.172.365.359-.084.391-.268.609.088.883.242.188.442.456.486.78.026.182.196.494-.015.602-.149.075-.259.507-.257.649.031.165.365.481.466.621.146.2.039.436.158.663.122.232.237.41.323.645.111.324.958-.007 1.156-.006.673.004 1.014-.944 1.487-1.235.267-.165.192-.616.51-.848.296-.215.608-.344.636-.741.021-.344-.259-1.062-.104-1.353l.102-.165zm-7.301-7.76c.041.172-.119.645-.154.795-.031.138.442.226.415.295.004-.008.642-.22.705-.275l.144-.323c.121-.081.248-.146.384-.196l.164-.285c.056-.021.71-.123.756-.101.165.075.469.389.583.531l.041.032c-.326-.67-.59-1.314-.796-1.942l-.083.036c-.222 0-.528.251-.663.405-.095.104-.669.337-.732.33.33.035.314.276.288.482-.068.476-1.096.035-1.052.216zm10.904 5.049c-.277 4.807-4.253 8.623-9.13 8.623-2.603 0-4.951-1.086-6.618-2.83-.198-.208-.346-.7-.02-.9l.331-.085c.259-.22-.242-1.111-.044-1.254.617-.441.324-.982-.055-1.429-.161-.19-1.043-1.1-1.143-.937.074-.249-.16-.85-.302-1.087-.239-.398-.553-.643-.679-1.081-.05-.174-.05-.704-.153-.826-.041-.05-.358-.185-.347-.257.305-1.82 1.147-3.458 2.364-4.751l.821-.33c.515-.773.545-.173 1.008-.375.154 0 .331-.634.496-.734.289-.185.068-.185.015-.27-.112-.184 2.411-1.103 2.453-.938.034.14-1.249.809-1.108.788-.326.043-.388.627-.328.625.163-.005 1.182-.774 1.657-.61.466.161 1.301-.37 1.627-.64l.04-.038c.029-.761.195-1.494.481-2.172l-.493-.026c-6.075 0-11 4.925-11 11s4.925 11 11 11c6.074 0 11-4.925 11-11 0-.764-.078-1.509-.227-2.229-.491.864-1.044 1.779-1.646 2.763zm1.873-9.1c0 2.45-1.951 5.373-4.5 9.566-2.549-4.193-4.5-7.116-4.5-9.566 0-2.449 2.139-4.434 4.5-4.434s4.5 1.985 4.5 4.434zm-2.75.066c0-.966-.784-1.75-1.75-1.75s-1.75.784-1.75 1.75.784 1.75 1.75 1.75 1.75-.784 1.75-1.75z"/></svg>',
        trade_types: '<svg class="svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M20 18c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zm-16 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zm8-14c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zm3.873 15.655l-2.873-2.404v-3.341c-.326.055-.658.09-1 .09s-.674-.035-1-.09v3.341l-2.873 2.404c.484.46.892 1 1.201 1.598l2.672-2.253 2.672 2.253c.309-.598.717-1.137 1.201-1.598z"></path></svg>',
        scales: '<svg class="svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 9c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm-9 4c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm18 0c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm-9-6c.343 0 .677.035 1 .101v-3.101c0-.552-.447-1-1-1s-1 .448-1 1v3.101c.323-.066.657-.101 1-.101zm9 4c.343 0 .677.035 1 .101v-7.101c0-.552-.447-1-1-1s-1 .448-1 1v7.101c.323-.066.657-.101 1-.101zm0 10c-.343 0-.677-.035-1-.101v3.101c0 .552.447 1 1 1s1-.448 1-1v-3.101c-.323.066-.657.101-1 .101zm-18-10c.343 0 .677.035 1 .101v-7.101c0-.552-.447-1-1-1s-1 .448-1 1v7.101c.323-.066.657-.101 1-.101zm9 6c-.343 0-.677-.035-1-.101v7.101c0 .552.447 1 1 1s1-.448 1-1v-7.101c-.323.066-.657.101-1 .101zm-9 4c-.343 0-.677-.035-1-.101v3.101c0 .552.447 1 1 1s1-.448 1-1v-3.101c-.323.066-.657.101-1 .101z"></path></svg>',
        providers: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 11.374c0 4.55-3.783 6.96-7.146 6.796-.151 1.448.061 2.642.384 3.641l-3.72 1.189c-.338-1.129-.993-3.822-2.752-5.279-2.728.802-4.969-.646-5.784-2.627-2.833.046-4.982-1.836-4.982-4.553 0-4.199 4.604-9.541 11.99-9.541 7.532 0 12.01 5.377 12.01 10.374zm-21.992-1.069c-.145 2.352 2.179 3.07 4.44 2.826.336 2.429 2.806 3.279 4.652 2.396 1.551.74 2.747 2.37 3.729 4.967l.002.006.111-.036c-.219-1.579-.09-3.324.36-4.528 3.907.686 6.849-1.153 6.69-4.828-.166-3.829-3.657-8.011-9.843-8.109-6.302-.041-9.957 4.255-10.141 7.306zm8.165-2.484c-.692-.314-1.173-1.012-1.173-1.821 0-1.104.896-2 2-2s2 .896 2 2c0 .26-.05.509-.141.738 1.215.911 2.405 1.855 3.6 2.794.424-.333.96-.532 1.541-.532 1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5c-1.171 0-2.155-.807-2.426-1.895-1.201.098-2.404.173-3.606.254-.17.933-.987 1.641-1.968 1.641-1.104 0-2-.896-2-2 0-1.033.784-1.884 1.79-1.989.12-.731.252-1.46.383-2.19zm2.059-.246c-.296.232-.66.383-1.057.417l-.363 2.18c.504.224.898.651 1.079 1.177l3.648-.289c.047-.267.137-.519.262-.749l-3.569-2.736z"/></svg>',
        titles: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M14.601 21.5c0 1.38-1.116 2.5-2.499 2.5-1.378 0-2.499-1.12-2.499-2.5s1.121-2.5 2.499-2.5c1.383 0 2.499 1.119 2.499 2.5zm-2.42-21.5c-4.029 0-7.06 2.693-7.06 8h3.955c0-2.304.906-4.189 3.024-4.189 1.247 0 2.57.828 2.684 2.411.123 1.666-.767 2.511-1.892 3.582-2.924 2.78-2.816 4.049-2.816 7.196h3.943c0-1.452-.157-2.508 1.838-4.659 1.331-1.436 2.986-3.222 3.021-5.943.047-3.963-2.751-6.398-6.697-6.398z"/></svg>',
        descriptions: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M14.601 21.5c0 1.38-1.116 2.5-2.499 2.5-1.378 0-2.499-1.12-2.499-2.5s1.121-2.5 2.499-2.5c1.383 0 2.499 1.119 2.499 2.5zm-2.42-21.5c-4.029 0-7.06 2.693-7.06 8h3.955c0-2.304.906-4.189 3.024-4.189 1.247 0 2.57.828 2.684 2.411.123 1.666-.767 2.511-1.892 3.582-2.924 2.78-2.816 4.049-2.816 7.196h3.943c0-1.452-.157-2.508 1.838-4.659 1.331-1.436 2.986-3.222 3.021-5.943.047-3.963-2.751-6.398-6.697-6.398z"/></svg>',
        data_series: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M14.601 21.5c0 1.38-1.116 2.5-2.499 2.5-1.378 0-2.499-1.12-2.499-2.5s1.121-2.5 2.499-2.5c1.383 0 2.499 1.119 2.499 2.5zm-2.42-21.5c-4.029 0-7.06 2.693-7.06 8h3.955c0-2.304.906-4.189 3.024-4.189 1.247 0 2.57.828 2.684 2.411.123 1.666-.767 2.511-1.892 3.582-2.924 2.78-2.816 4.049-2.816 7.196h3.943c0-1.452-.157-2.508 1.838-4.659 1.331-1.436 2.986-3.222 3.021-5.943.047-3.963-2.751-6.398-6.697-6.398z"/></svg>',
        published: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M17 3v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1zm-12 1c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v2c0 .552.447 1 1 1zm13 13v-3h-1v4h3v-1h-2zm-5 .5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5zm11 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5zm-14.237 3.5h-7.763v-13h19v1.763c.727.33 1.399.757 2 1.268v-9.031h-3v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-9v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-3v21h11.031c-.511-.601-.938-1.273-1.268-2z"/></svg>'
      }
    }
  },
  computed: {
    selectedChartTimeline () {
      return this.$store.getters['search/getSelectedChartTimeline']
    },
    activeFilter () {
      return this.$store.getters['search/getActiveFilter']
    }
  },
  methods: {
    clicked (value) {
      this.$emit('clicked', value)
    },
    highlighted (value) {
      this.$emit('highlighted', value)
    },
    downplayed (value) {
      this.$emit('downplayed', value)
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.item {
  position: relative;
  display: inline-flex;
  align-items: center;
  fill: rgba($white, 0.7);
  height: 28px;
  padding: 0px 12px;
  margin: 0px 4px;
  border-radius: 999px;
  outline: 0;
  user-select: none;
  transition: fill 0.25s ease-out, color 0.25s ease-out; //, background-color 0.25s ease-out !important;
  //border: 2px solid rgba($white, 0.175);

  &:hover {
    fill: $white;

    .item__close {
      opacity: 1;
      //transition: opacity 0.2s ease-out;
    }
  }

  &--filter {
    display: inline-flex;
    align-items: center;
  }

  &--timeline {
    padding: 0px 2px;
  }

  &--legend {
    display: inline-flex;
    align-items: center;
    padding: 3px 6px;
    margin: 0px;
    border-radius: 4px;
  }

  &--active {
    background-color: $bg-4;

    &:hover, &:active, &:focus {
      background-color: $bg-2;

      .item__legendIcon {
        transform: scale(1.15);
      }
    }
  }

  &--inactive {
    //background-color: $bg-2;
    color: rgba($white, 0.5);

    &:hover, &:active, &:focus {
      color: rgba($white, 0.8);
    }

    .item__legendIcon {
      background-color: rgba($white, 0.25) !important;
    }
  }

  &__legendIcon {
    background-color: $blue;
    width: 1rem;
    height: 1rem;
    margin-right: 8px;
    margin-left: 2px;
    border-radius: 4px;
    transition: transform 0.2s, background-color 0.2s;
  }

  &__legendName {
    margin-right: 6px;
  }

  &__icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;

    @media screen and (min-width: $breakpointLg) {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
  }

  &__text {
    @include font('content--md');
    //user-select: none;
    width: auto;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg');
    }

    /deep/span {
      color: rgba($white, 0.7);
    }
  }

  &__timeline {
    @include font('content--sm', $white, 0.7);
    user-select: none;
    font-weight: 500;
    width: auto;
    padding: 2px 8px;
    border: 1px solid rgba($blue, 0);
    border-radius: 4px;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--md');
      padding: 2px 8px;
    }

    /deep/span {
      color: rgba($white, 0.7);
    }

    &:hover:not(.item__timeline--disabled) {
      background-color: $bg-3;
      color: $white;
      cursor: pointer;
    }

    &--selected, &:active {
      background-color: $bg-4;
      border-color: $bg-4;
      border-radius: 4px;
      color: $blue;
      cursor: pointer;
    }

    &--disabled {
      color: rgba($white, 0.5);
    }
  }

  &__close {
    position: absolute;
    display: inline-flex;
    opacity: 0;
    align-items: center;
    user-select: none;
    right: 2px;
    background-color: $bg-2; //$bg-1;
    padding: 7px;
    border-radius: 999px;
    width: 12px;
    height: 12px;
    fill: $white;
    cursor: pointer;

    &:hover {
      fill: $white !important;
      cursor: pointer;

      svg {
        transform: scale(1.15);
      }
    }

    &:focus, &:active {
      svg {
        transform: scale(1);
      }
    }

    svg {
      transition: fill 0.2s ease-out;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &--disabled {
    fill: rgba($white, 0.5) !important;
    background-color: rgba($white, 0.1) !important;

    &:hover {
      background-color: rgba($white, 0.07) !important;
    }

    .item__text {
      color: rgba($white, 0.5) !important;
    }
  }

  &--queries {
    fill: $purple;

    &Active {
      fill: $white;
      background-color: rgba($purple, 0.4);
    }

    &:hover {
      background-color: rgba($purple, 0.3);
    }
  }

  &--titles, &--descriptions, &--data_series, &--published {
    fill: $pink;

    &Active {
      fill: $white;
      background-color: rgba($pink, 0.4);
    }

    &:hover {
      background-color: rgba($pink, 0.3);
    }
  }

  &--topics {
    fill: $blue;

    &Active {
      fill: $white;
      background-color: rgba($blue, 0.5);
    }

    &:hover {
      background-color: rgba($blue, 0.4);
    }
  }

  &--locations {
    fill: $green;

    &Active {
      fill: $white;
      background-color: rgba($green, 0.4);
    }

    &:hover {
      background-color: rgba($green, 0.3);
    }
  }

  &--trade_types {
    fill: $yellow;

    &Active {
      fill: $white;
      background-color: rgba($yellow, 0.55);
    }

    &:hover {
      background-color: rgba($yellow, 0.4);
    }
  }

  &--scales {
    fill: $orange;

    &Active {
      fill: $white;
      background-color: rgba($orange, 0.5);
    }

    &:hover {
      background-color: rgba($orange, 0.4);
    }
  }

  &--providers {
    fill: $pink;

    &Active {
      fill: $white;
      background-color: rgba($pink, 0.5);
    }

    &:hover {
      background-color: rgba($pink, 0.5);
    }
  }
}

</style>
